import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { IItem } from '../../models/group-edit-config';
import { FormControl } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { CustomErrorStateMatcher } from '../../models/custom-error-state';
import { MAT_UK_DATE_FORMATS } from '../../models/nt-company';
import { CompanyService } from '../../../../services/company.service';
import { Subject, takeUntil } from 'rxjs';
import { OverrideMomentDateAdapter } from '../../models/matDateAdapterOverride';

@Component({
  selector: 'app-field-editor',
  templateUrl: './field-editor.component.html',
  styleUrls: ['./field-editor.component.scss']
})
export class FieldEditorComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() control!: FormControl;
    errorState = new CustomErrorStateMatcher();
    localConfig!: IItem;
    @Input() set config(_c : IItem){
        this.localConfig = _c;
    }

    company: any;

    @ViewChild('datePicker') picker: any;
    sub = new Subject();
    
    constructor(private comp: CompanyService) { }

    ngOnInit(): void {
        this.localConfig.updateMethod = (item: IItem) => {
            this.localConfig = item;
        }

        this.init();
    }

    ngOnDestroy(): void {
        this.sub.next(false);
        this.sub.complete();
    }

    ngAfterViewInit(): void {
       // this.updateDateBinding();
    }

    init(){
        
    }

    // updateDateBinding(){
    //     if(!this.picker || !this.company){
    //         return;
    //     }

    //     if (this.company.region.indexOf('US') > -1 || this.company.region.indexOf('CA') > -1) {
    //         const d = this.picker._datepickerInput._dateFormats;
    //         d.parse.dateInput = 'MM/DD/YYYY';
    //         d.display.dateInput = 'MM/DD/YYYY';
    //         this.picker._datepickerInput._dateFormats = d;
    //     }
    // }

}
